export class NotImplementedError extends Error {
    constructor(msg?: string) {
        super(msg ?? 'Not implemented');
    }
}

export function throwNotImplementedError() {
    throw new NotImplementedError();
}
